import React from "react";
import "../css/App.css";
import PrivateRoute from "./PrivateRoute"
import Home from "./Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import InstructorHome from "./Instructor/InstructorHome";
import StudentHome from "./Student/StudentHome"
import AwaitingExcercise from "./Student/AwaitingExcercise";
import NewExercise from "./Instructor/NewExercise";
import WriteProblemStatement from "./Instructor/WriteExcercise";
import PreviewStatement from "./Instructor/PreviewStatement";
import PollingResponses from "./Instructor/PollingResponses";
import ViewAnswers from "./Instructor/ViewAnswers";
import ShowSteps from "./Instructor/ShowSteps";
import WriteAnswer from "./Student/WriteAnswer";
import WhiteBoard from "./Student/WhiteBoard";
import Submitted from "./Student/Submitted";


function App() {

  return (
    <div className="App primary text-light">
    <Router>
   
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/instructor/home" component={InstructorHome} />
        <PrivateRoute path="/instructor/new_exercise" component={NewExercise} />
        <PrivateRoute path="/instructor/write_exercise" component={WriteProblemStatement} />
        <PrivateRoute path="/instructor/preview_statement" component={PreviewStatement} />
        <PrivateRoute path="/instructor/polling_responses" component={PollingResponses} />
        <PrivateRoute path="/instructor/view_answers" component={ViewAnswers} />
        <PrivateRoute path="/instructor/show_steps" component={ShowSteps} />

        <Route path="/student/login" component={StudentHome} />
        <PrivateRoute path="/student/awaiting" component={AwaitingExcercise} />
        <PrivateRoute path="/student/write_answer" component={WriteAnswer} />
        <Route path="/student/writting_pad" component={WhiteBoard} />
        <PrivateRoute path="/student/write_submitted" component={Submitted} />
      </Switch>
    
    </Router>
    </div>
  );
}

export default App;
